import { SolicitacaoVistoriaAnalise } from "./SolicitacaoVistoriaAnalise";

export default SolicitacaoVistoriaAnalise;